import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enMessage from "i18n/locales/en/message.json";
import enResource from "i18n/locales/en/resource.json";
import koMessage from "i18n/locales/ko/message.json";
import koResource from "i18n/locales/ko/resource.json";

/** i18next 세팅 */
i18n.use(initReactI18next).init({
  lng: "EN",
  fallbackLng: "KO",
  defaultNS: "resource",
  ns: ["resource", "message"],
  resources: {
    EN: {
      resource: enResource,
      message: enMessage,
    },
    KO: {
      resource: koResource,
      message: koMessage,
    },
  },
});

export default i18n;
